/** 各フェーズ定義 */
export const PHASE = {
  STANDBY_ENGINE_START: "standbyEngineStart", //エンジン始動指示
  STANDBY_FORCED_PLAYBACK: "standbyForcedPlayback", //GPF強制再生確認表示
  STANDBY_PLAYBACK: "standbyPlayback", // GPF再生確認表示
  EXECUTION: "execution", //実行
  EXECUTION_MONITORING_STATUS: "executionMonitoringStatus", //GPF再生状態確認(2回目以降)
  EXECUTION_MONITORING_CANCEL: "executionMonitoringCancel", //GPF再生中止確認表示
  COOLING_DISPLAY: "coolingDisplay", //冷却中表示(通常監視)
  INSTRUCTION_DISPLAY: "instructionDisplay", //IG_OFF指示表示
  IG_OFF_STANDBY: "igOffStandby", //IG_OFF待機
  SUCCESS: "success", //完了表示(通常監視)
  INTERRUPTION_COOLING_DISPLAY: "interruptionCoolingDisplay", //冷却中表示(中断監視)
  COOLING_COMPLETED: "coolingCompleted", // 完了表示(中断監視)
  START_CONDITION_ERROR: "startConditionError", //開始条件不成立表示
  GPF_ERROR: "gpfError", //GPF再生異常表示(冷却不要)
  FIRST_COOLING_DISPLAY: "firstCoolingDisplay",//冷却中表示1
  FIRST_COOLING_COMPLETED: "firstCoolingCompleted",//冷却完了表示1
  SECOND_COOLING_DISPLAY: "secondCoolingDisplay",//冷却中表示2
  SECOND_COOLING_COMPLETED: "secondCoolingCompleted",//冷却完了表示2
  THIRD_COOLING_DISPLAY: "thirdCoolingDisplay",//冷却中表示3
  THIRD_COOLING_COMPLETED: "thirdCoolingCompleted",//冷却完了表示3
  COMMUNICATION_ERROR: "communicationError", //通信エラー
  COMMON_ERROR: "commonError", //共通エラー
};

/** 時間 */
export const TIME = {
  INITIAL_TIME_FOR_COOLING: 600000, // 冷却中表示の初期表示時間(10分)
  INITIAL_TIME_FOR_IG_OFF: 15000, // IG_OFF待機の初期表示時間(15秒)
  INTERVAL_FOR_COOLING: 60000, // 冷却中表示の更新間隔(60秒)
  INTERVAL_FOR_IG_OFF: 1000, // IG_OFF待機の更新間隔(1秒)
};

/** データ読出し結果 */
export const READ_RESULT_TYPE = {
  FORCE: "force",
  NORMAL: "normal",
  NG: "ng",
  OTHER: "other"
};

/** ルーチン実行結果 */
export const EXECUTION_ROUTINE_RESULT_TYPE = {
  ABNORMAL: "abnormal",
  RETRY: "retry"
};

/** ルーチン結果確認結果 */
export const CHECK_ROUTINE_RESULT_TYPE = {
  STOP: "stop",
  COOLING1: "cooling1",
  COOLING2: "cooling2",
  COOLING3: "cooling3",
  OTHER: "other"
};